export const dataTabDashboard = ["Overview", "NFTs", "Tx History"];
export const dataTabStake = ["Stake", "UnStake"];
export const dataTabValidator = ["Overview", "NFTs", "Tx History"];
